import { createTheme } from '@mui/material';
import { theme } from '#components/Layout';

export default createTheme(
  theme,
  {
    typography: {
      h1: {
        ...theme.typography.h2,
      },
      h3: { ...theme.typography.h2 },
      fouxH1: {
        ...theme.typography.h1,
        fontSize: '5rem',
        [theme.breakpoints.between('md', 'lg')]: {
          fontSize: '4.2rem',
          lineHeight: 1.2,
        },
        [theme.breakpoints.between('sm', 'md')]: {
          fontSize: '3.8rem',
          lineHeight: 1.2,
        },
        [theme.breakpoints.down('sm')]: {
          fontSize: '3.2rem',
          lineHeight: 1.2,
        },
      },
      subheading1: {
        ...theme.typography.subheading1,
        fontSize: '1.75rem',
      },
    },
  },
);
